var _defs, _rect, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillingSupplierBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1297 508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edeefc;}.cls-2{fill:#dedff6;}.cls-3{fill:#040227;}.cls-4{fill:#c5c9f6;}.cls-5{fill:#22d696;}.cls-6{fill:#e9a4b3;}.cls-7{fill:#e55353;}.cls-8{fill:#00a7ff;}.cls-9{fill:#219367;}.cls-10{fill:#525252;}.cls-11{fill:#aaaeb9;}.cls-12{fill:#0d37c9;}.cls-13{fill:#d998a9;}.cls-14{fill:#2c3a64;}.cls-15{fill:none;stroke:#c9798d;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Surface-2",
    className: "cls-1",
    x: 8.32,
    y: 72.69,
    width: 1280,
    height: 423,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-2",
    d: "M746,80.56,891,9.17,942.7,114.22l10.9,22.13-33-11.23L797.76,185.61Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-3",
    d: "M763.45,84.08,900.83,16.41l49,99.57,10.33,21L928.9,126.32,812.49,183.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "ic_attach_money_24px-2",
    "data-name": "ic attach money 24px-2",
    className: "cls-4",
    d: "M854.94,93.24c-9.82,2.27-13.81,1.4-15.7-2.22-2.17-4.15.17-9,6.6-12.41,6.77-3.54,11-1.61,13.69,3l8.41-4.39a17.12,17.12,0,0,0-19.8-8.12l-4.35-8.32-11.41,6,4.3,8.22c-6.55,5.46-10,13.38-6.15,20.69,4.59,8.79,14.15,9.37,26.1,6.37,10.7-2.69,14.36-.33,16.21,3.21,1.37,2.62,1.69,7.78-6.72,12.18-7.84,4.1-12.75,2.2-15.51-2.06l-8.37,4.38c4.81,8.09,13.5,9.51,21.62,7.26l4.31,8.25,11.41-6-4.27-8.17c6.69-5.29,10.34-12.67,6.27-20.47C875.93,89.83,864.75,91,854.94,93.24Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87-2",
    "data-name": "Group 87-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134-2",
    "data-name": "Path 134-2",
    className: "cls-5",
    d: "M1208,403.06c-.86,6-36.63,31-43.68,36-5.66,4-10.57,5.87-19.12,9.08h0c-19.43,5.1-141.32,41.48-141.32,41.48a16.11,16.11,0,0,0-1.21-3.71c-4.56,1.82-9.24,3-12.21,3.93-4.54,1.41-40.56,2.54-47.94,4s-22.12,3.68-28.08-2,3.69-17.87,11.92-21,38.29-4,43.68-4.54,12.48-2.55,15.88-1.42c1.07.36,5.83-1,11.83-3.11-.15-2.21-.19-3.6-.19-3.6l32-9.23-5.92-56.67s13.92-52.47,69.56-12.44c0,0,12.41,3.65,16.66,4.78a4.89,4.89,0,0,0,1.43.05c8.49-.65,45-11.67,58.14-11.67,14.18,0,18.72-.86,23.82,1.7S1208.86,397.1,1208,403.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135-2",
    "data-name": "Path 135-2",
    className: "cls-5",
    d: "M1151,491.84c-6,5.67-20.71,3.4-28.08,2s-43.4-2.56-47.94-4-13-3.4-19-7.38a19.56,19.56,0,0,0-3.18-1.4h0l-9,6.49L918.55,447.71c-7.5-2-13.46-5.18-17.42-8.63-6.53-5.67-42.83-30.07-43.68-36s9.64-25.81,14.75-28.36S881.85,373,896,373s55.31,12.76,59.57,11.62c1.93-.51,5.94-2.55,9.73-4.62,4.55-2.49,8.8-5,8.8-5,60.91-27.19,67.7,17.3,67.7,17.3l-3.61,54.93s5.07,2.52,11.68,5.66l30.19,8.53-3.95,2.85a7.68,7.68,0,0,0,3.41.64c3.4-1.13,10.49.85,15.88,1.42s35.46,1.42,43.68,4.54S1157,486.17,1151,491.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136-2",
    "data-name": "Path 136-2",
    className: "cls-5",
    d: "M965.32,380c4.2.29,32.59,16.73,39.32,20.66-10.23-5.35-49-16-49-16C957.52,384.11,961.53,382.06,965.32,380Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137-2",
    "data-name": "Path 137-2",
    className: "cls-5",
    d: "M1111.3,384.66s-48.9,11.87-57.85,16.84c.4-.3,25.77-19.57,39.09-22.14,0,0,13.08,4.13,17.33,5.26a4.51,4.51,0,0,0,1.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138-2",
    "data-name": "Path 138-2",
    className: "cls-6",
    d: "M1151,491.84c-6,5.68-20.71,3.4-28.08,2s-43.4-2.55-47.93-4c-1.31-.41-2.94-.86-4.75-1.4h0c-4.47-1.32-10-3.15-14.26-6a19.14,19.14,0,0,0-3.18-1.39l22.67-16.36.65-.47a7.68,7.68,0,0,0,3.41.64c3.4-1.13,10.49.85,15.88,1.42s35.45,1.42,43.68,4.54S1157,486.17,1151,491.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139-2",
    "data-name": "Path 139-2",
    className: "cls-3",
    d: "M1151,491.84c-6,5.68-20.71,3.4-28.08,2s-43.4-2.55-47.94-4c-1.31-.41-2.94-.86-4.74-1.4h0s9.91-9.8,5.23-23.72l.65-.47a8,8,0,0,0,3.41.64c3.4-1.14,10.49.85,15.88,1.42s35.45,1.41,43.68,4.53S1157,486.17,1151,491.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140-2",
    "data-name": "Path 140-2",
    className: "cls-7",
    d: "M977.75,392.52c.06.15,0,.26,0,.33C977.14,393.28,977.24,393.09,977.75,392.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141-2",
    "data-name": "Path 141-2",
    className: "cls-8",
    d: "M1141.69,326.2c-.48-1-26.32-41.6-33.31-60.14s-23.83-27-31.77-29.68c-2.83-.95-7.88-2.59-13.21-4.32-9.59-3.1-20.06-6.46-20.06-6.46h-33.1s-11.47,3.84-23.65,8.11h0c-11.22,3.94-23,8.23-27,10.23-8.32,4.16-22.32,33.84-25.15,37.25s-24.65,43.83-27.8,59.37c-2.45,12.08,69.19,47.43,71.14,52C980,390,990.45,380,990.45,380s-3.34-2.1-8.05-5.2c19.19.88,66.08-.78,72.81-.44a34.74,34.74,0,0,0,4.33-.09h0c2.08,1.52,15.5,13.38,15.5,13.38s33.1-13.74,48.32-29.12C1145,336.69,1144.06,331,1141.69,326.2ZM953.53,353.09c-7.09-8.51-16.85-13.66-14.4-17.44s23.26-39.71,23.26-39.71,10.78,23.64,13.81,35.93,2.79,17.92,1.51,21.74c-1.15,3.43-2.06,5.76-3.09,16-8.49-5.79-17.85-12.59-21.09-16.49ZM1099.84,349c-2.78,3.16-13.78,10.15-23.68,15.9-.75-6.86-1.89-17.65-2-21.53-.19-5.86,2.27-22.69,5.3-29.12s5.1-24,5.1-24,25,34,29,37.63-4.35,10.46-13.74,21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142-2",
    "data-name": "Path 142-2",
    className: "cls-9",
    d: "M992.65,432.9S953,409.16,935.73,405.43c-16.35-3.54-22.32-9.65-22.32-9.65s26,0,43.3,12.3C968.47,416.42,992.65,432.9,992.65,432.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143-2",
    "data-name": "Path 143-2",
    className: "cls-9",
    d: "M1027.84,449.45s68.9-36.18,97-44c16.11-4.5,22.31-9.65,22.31-9.65s-42.6,4.16-68.5,19.76C1066.34,423,1027.84,449.45,1027.84,449.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144-2",
    "data-name": "Path 144-2",
    className: "cls-6",
    d: "M1002.67,485.93c-4.55,1.82-9.23,3-12.21,3.93-4.54,1.41-40.56,2.55-47.94,4s-22.12,3.68-28.07-2,3.69-17.87,11.91-21,38.29-4,43.68-4.54,12.48-2.55,15.88-1.42c1.07.36,5.83-1,11.83-3.11C997.93,465.38,1002.67,485.93,1002.67,485.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145-2",
    "data-name": "Path 145-2",
    className: "cls-5",
    d: "M1027.84,482.5l67.74-20-13.4-4.09S1028.05,478,1027.84,482.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146-2",
    "data-name": "Path 146-2",
    className: "cls-5",
    d: "M1027.84,482.51l31.7-9.67-22,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147-2",
    "data-name": "Path 147-2",
    className: "cls-10",
    d: "M1006.06,401.5l-1.42-.84A13.57,13.57,0,0,1,1006.06,401.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148-2",
    "data-name": "Path 148-2",
    className: "cls-3",
    d: "M990.46,489.86c-4.54,1.41-40.56,2.55-47.94,4s-22.12,3.68-28.08-2,3.69-17.87,11.92-21,38.29-4,43.68-4.54,12.48-2.55,15.88-1.42C985.92,464.89,976.83,478.8,990.46,489.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149-2",
    "data-name": "Path 149-2",
    className: "cls-11",
    d: "M968.07,395.78l-10.44-59.37,134.95-3.12-8.69,58.43s-43.08,15.76-57.7,25C1026.19,416.68,989.24,401.5,968.07,395.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150-2",
    "data-name": "Path 150-2",
    className: "cls-12",
    d: "M1034.14,372.21c0,4.91-3.39,8.89-7.57,8.89s-7.56-4-7.56-8.89,3.39-8.88,7.56-8.88S1034.14,367.3,1034.14,372.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151-2",
    "data-name": "Path 151-2",
    className: "cls-6",
    d: "M1043.67,225.7l0-.1c-1.61-3.61-.82-21.19-.82-21.19s-33-8.39-32-2-2.84,23.92-2.84,23.92L991,232.15s18,48.37,38.72,42.14,28.52-43.88,28.52-43.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152-2",
    "data-name": "Path 152-2",
    className: "cls-13",
    d: "M1011.4,209.72a19.19,19.19,0,0,0,14.38,6.7c6.07,0,10.2-1.49,16.24-7.38,0,0-2.4,11-16.2,12C1025.83,221.06,1016,222.48,1011.4,209.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_153-2",
    "data-name": "Path 153-2",
    className: "cls-14",
    d: "M1005.53,199s-3.52-17.54-6-22.85-4.5-29,22.68-30.25c0,0,10.42,1.23,16.15-2.25,0,0,0,3.48-1.43,4.7a18.05,18.05,0,0,1,16.75,5.93c7.36,8.17-4.9,36.78-4.29,43.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154-2",
    "data-name": "Path 154-2",
    className: "cls-6",
    d: "M1049.83,174.58v19.14a22.47,22.47,0,0,1-2,9.1h0a29.05,29.05,0,0,1-9.8,11.83c-3.54,2.49-7.35,3.91-10.61,3.86-2.83-.06-6.52-1.44-10.08-3.81-4.8-3.18-9.38-8.13-11.33-13.95l0-.09-.07-.24a18.36,18.36,0,0,1-.89-5.55V174.58c0-4.75,3.32-8.63,7.36-8.63h30.08C1046.52,166,1049.83,169.83,1049.83,174.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155-2",
    "data-name": "Path 155-2",
    className: "cls-14",
    d: "M1005,185.41s.05-12.19,9.7-14.06,31.27,5.94,34.34-2.95-41.77-8.74-44-3.07S1005,185.41,1005,185.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156-2",
    "data-name": "Path 156-2",
    className: "cls-14",
    d: "M1038,206.21v8.44c-3.54,2.49-7.35,3.92-10.61,3.86-2.83-.06-6.52-1.44-10.08-3.8v-8.49a8.58,8.58,0,0,1,8.56-8.57h3.57A8.58,8.58,0,0,1,1038,206.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157-2",
    "data-name": "Path 157-2",
    className: "cls-14",
    d: "M1047.84,202.82c-4,9.22-13.49,15.81-20.41,15.69-6.65-.12-18-7.62-21.41-17.76l0-.09-.07-.24s7.14,6.1,11.87,3.07h19.85A9.79,9.79,0,0,0,1047.84,202.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158-2",
    "data-name": "Path 158-2",
    className: "cls-6",
    d: "M1029.84,205.18h-4.28c-1,0-2.23-1.6-2.23-2.59a4.78,4.78,0,0,1,2.23-1h4.28a3.58,3.58,0,0,1,2.64,1.4A2.93,2.93,0,0,1,1029.84,205.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088-2",
    "data-name": "Path 2088-2",
    className: "cls-15",
    d: "M1027.93,183.82s-.15,4.4,4.26,4.55c0,0-2.36,4.61-4.56,4.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingSupplierBanner);
export default __webpack_public_path__ + "static/media/billing-supplier-banner.a794dd4b26b43e74c208f74cc0b5ae94.svg";
export { ForwardRef as ReactComponent };